/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface CreateAuthorityDto
 */
export interface CreateAuthorityDto {

    /**
     * @type {string}
     * @memberof CreateAuthorityDto
     */
    name: string;

    /**
     * @type {string}
     * @memberof CreateAuthorityDto
     */
    description?: string;

    /**
     * @type {JoinEntityDto}
     * @memberof CreateAuthorityDto
     */
    client?: JoinEntityDto;

    /**
     * @type {Array<JoinEntityDto>}
     * @memberof CreateAuthorityDto
     */
    permissions: Array<JoinEntityDto>;
}
